import React from 'react';
import './button.css';

const Btn = (props) => {
    return ( 
        <>
        <button className='btn'>
            <h3>MORE DETAILS</h3>
            <div className="btn-arrow"></div>
        </button>
        </>
     );
}
 
export default Btn;